import { browserHistory } from 'react-router'
import React, {Component} from 'react'
import LabelEditForm from "./form/edit.component.jsx"
import SideBar from '../common/layout/sidebar.component.jsx'

class LabelNew extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
        }
    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
    }

    render() {
        return (
            <div>
                <LabelEditForm />
            </div>
        );
    }
}

export default LabelNew


// WEBPACK FOOTER //
// ./src/label/new.component.jsx